<template>
  <div v-click-outside="closeOptions" class="hk-select" :class="{ disabled }">
    <input
      v-if="required"
      class="visually-hidden hk-select-validation"
      type="text"
      tabindex="-1"
      aria-hidden="true"
      :value="modelValue"
      :disabled="disabled"
      required
    />
    <a ref="select-anchor" data-bs-toggle="collapse" aria-expanded="false" role="button" :data-bs-target="$idRef('collapseOptions')" @click="changeStatus()">
        <span :class="optionSelected? optionSelected.color : ''">{{ optionSelected? optionSelected.label: placeholder }}</span>
    </a>
    <div :id="$id('collapseOptions')" class="hk-select-options mt-2 collapse scroll">
      <ul v-if="options != null">
        <li v-for="(
                      item,
                      index
                    ) of optionsValue" :key="index" data-value="item.value" :class="item.color" @click="select(item)">{{ item.label }}</li>
      </ul>
      <div v-else>
        <span>{{ $t('key_no_file_selected')}}</span>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "HkSelect",
  props: {
    modelValue: {
      type: [String, Number],
      default: ""
    },
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      isOpen: false,
      optionsValue: null,
      optionSelected: null,
    };
  },
  watch: {
    modelValue(val) {
      this.loadValue(val);
    },
    options(val){
    this.optionsValue = val;
      this.loadValue(this.modelValue);
    }
  },
  mounted() {
    this.optionsValue = this.options;
    this.loadValue(this.modelValue);
  },
  methods: {
    loadValue(val) {
      this.optionSelected = null;
      for (let index = 0; index < this.optionsValue.length; index++) {
        const element = this.optionsValue[index];
        if (element.value === val) {
          this.optionSelected = element;
        }
      }
    },
    changeStatus() {
      if (this.disabled) {
        return;
      }
      this.isOpen = !this.isOpen;
    },
    closeOptions() {
      if (this.isOpen) {
        this.$refs['select-anchor'].click();
      }
    },
    select(option){
      if (this.disabled) {
        return;
      }
      this.optionSelected = option;
      this.$emit('update:modelValue', option.value);
      this.closeOptions();
    }
  },
};
</script>
<style scoped>
.scroll{
  max-height: 200px;
  overflow: auto !important;
}
.hk-select.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
</style>
<style>
.was-validated .hk-select-validation:invalid ~ a {
  border-color: #ea0606;
}
</style>